import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { User } from '../../../models/user';
import { AuthService } from '../../../services/auth.service';
import { DrawerService } from '../../../services/drawer.service';
import { Logo } from '../../common/logo/logo';
import { SiteName } from '../../common/site-name/site-name';
import { BoutiquehubButton } from '../boutiquehub-button/boutiquehub-button';
import { FashionGoButton } from '../fashion-go-button/fashion-go-button';

@Component({
  selector: 'footer[app-main-footer]',
  imports: [
    RouterModule,
    Logo,
    SiteName,
    MatIconModule,
    FashionGoButton,
    BoutiquehubButton,
  ],
  templateUrl: './main-footer.html',
  styleUrl: './main-footer.scss',
})
export class MainFooter {
  constructor(
    private drawerService: DrawerService,
    private authService: AuthService
  ) {}
  toggleShoppingBag() {
    this.drawerService.toggleCart();
  }

  get profile(): User | null {
    return this.authService.profile();
  }

  get appname(): string {
    return environment.appname;
  }
}
